import classNames from 'classnames';
import type { JSX } from 'react';
import React, { Fragment } from 'react';
import type { OptionProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import { EMouseLeaveDelay, Tooltip } from '@feathr/components';

import type { IAdCategory } from './MetaAdCategorySelect';

import * as styles from './AdCategoryOption.css';

function AdCategoryOption(props: OptionProps<IAdCategory>): JSX.Element {
  const { data } = props;
  const option = (
    <components.Option {...props}>
      <Fragment key={data.id}>
        {data.name}
        <div
          className={classNames(styles.description, {
            [styles.disabled]: data.isDisabled,
          })}
        >
          <p>{data.description}</p>
        </div>
      </Fragment>
    </components.Option>
  );
  return data.tooltip ? (
    <Tooltip
      className={styles.tooltipWrapper}
      closeDelay={EMouseLeaveDelay.Link}
      title={data.tooltip}
    >
      {option}
    </Tooltip>
  ) : (
    option
  );
}

export default AdCategoryOption;
